import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { CustomInput } from "../CustomInput";
import xIcon from "../../assets/Profile/XIcon.svg";
import addIcon from "../../assets/Home/icon-plus.svg";
import img from "../../assets/Profile/img.png";
import axios from "axios";
import Swal from "sweetalert2";

const api = process.env.REACT_APP_API_URL;

const PropertyEditModal = ({ propertyId, onClose, propertyData, setProperties, type }) => {
  const [coverPreview, setCoverPreview] = useState(null);
  const [coverFile, setCoverFile] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: {
      propertie_id: "",
      model: "",
      floor: "",
      orientation: "",
      list_price: "",
      rooms_number: "",
      bathrooms_number: "",
      parking_places: "",
      development_id: "",
      building_surface: "",
      terrace_surface: "",
      balcony_surface: "",
      warehouse_surface: "",
      total_surface: "",
      status: "Disponible",
      type: type === 'Departamento' ? "departamento" : type === 'Casa' ? "casa" : "local",
      // enterprise_description: "",
      // enterprise_image: null
    },
  });

  useEffect(() => {
    if (propertyData) {
      Object.keys(propertyData).forEach((key) => {
        setValue(key, propertyData[key]);
      });
      // Si hay imagen previa, establecer el preview usando la URL completa
      if (propertyData.images_path) {
        setCoverPreview(`${api}${propertyData.images_path}`);
      }
    }
  }, [propertyData, setValue]);

  const onSubmit = async (data) => {
    const newData = {...data}
    // console.log("Data to submit:", newData);
    
    setProperties((prevElements) =>
      prevElements.map((element) => {
        // console.log(element.key, propertyId);
        // element.key === propertyId
        //   ? console.log("Nuevo:",  {...element, ...newData})
        //   : console.log("Viejo:", element);
        return element.key === propertyId ? {...element, ...newData} : element
      })
    );

    onClose && onClose(propertyData);
    // try {
    //   const formData = new FormData();

    //   // Agregar todos los datos del formulario excepto la imagen
    //   Object.keys(data).forEach((key) => {
    //     if (
    //       data[key] !== undefined &&
    //       data[key] !== null &&
    //       key !== "images_path"
    //     ) {
    //       formData.append(key, data[key]);
    //     }
    //   });

    //   const response = await axios.patch(
    //     `${api}/propertie/update/${propertyId}`,
    //     formData,
    //     {
    //       headers: {
    //         "Content-Type": "multipart/form-data",
    //       },
    //     }
    //   );
      

    //   if (response.data.success) {
    //     setElements((prevElements) =>
    //       prevElements.map((element) =>
    //         element.key === propertyId ? {...response.data.data, key: response.data.data.id } : element
    //       )
    //     );
    //     await Swal.fire({
    //       icon: "success",
    //       title: "¡Propiedad actualizada!",
    //       text: "Los datos se han actualizado correctamente",
    //       showConfirmButton: false,
    //       timer: 1500,
    //     });
    //     onClose && onClose(response.data);
    //   }
    // } catch (error) {
    //   console.error("Error al actualizar:", error);
    //   await Swal.fire({
    //     icon: "error",
    //     title: "Error",
    //     text: "Hubo un error al actualizar la propiedad",
    //     showConfirmButton: true,
    //   });
    // }
  };

  return (
    <div className="fixed inset-0 bg-black/50 pt-28 flex justify-center z-[60]">
      <div className="bg-white rounded-lg p-6 w-[800px] max-w-4xl max-h-[75vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl">Editar Propiedad</h2>
          {/* <h1 className="text-2xl font-bold">ID: {propertyId}</h1> */}
          <img
            onClick={onClose}
            src={xIcon}
            alt="Cerrar"
            className="cursor-pointer hover:rotate-90 transition-all duration-300"
          />
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Clave
              </label>
              <CustomInput
                label="Clave"
                {...register("propertie_id", { required: "La clave es requerida" })}
                error={errors.propertie_id?.message}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Estado
              </label>
              <select
                {...register("status", { required: "El estado es requerido" })}
                className={`w-full p-3 border rounded-md ${
                  errors.status ? "border-red-500" : "border-gray-300"
                }`}
              >
                <option value="Disponible">Disponible</option>
                <option value="Apartado">Apartado</option>
                <option value="Vendido">Vendido</option>
              </select>
              {errors.status && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.status.message}
                </p>
              )}
            </div>
            <div>
              <label onClick={() => console.log(type)} className="block text-sm font-medium text-gray-700 mb-1">
                Tipo de propiedad
              </label>
              <select
                {...register("type", { required: "El tipo es requerido" })}
                className={`w-full p-3 border rounded-md ${
                  errors.status ? "border-red-500" : "border-gray-300"
                }`}
              >
                { type === 'Departamento' ?
                  <>
                    <option value="departamento">Departamento</option>
                    <option value="estudio">Estudio</option>
                    <option value="loft">Loft</option>
                    <option value="lockoff">Lock-off</option>
                    <option value="penthouse">Penthouse</option>
                  </>
                :
                  type === 'Local' ?
                    <option value="local">Local</option>
                    :
                    <option value="casa">Casa</option>
                }
              </select>
              {errors.status && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.status.message}
                </p>
              )}
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Modelo
              </label>
              <CustomInput
                label="Modelo"
                {...register("model", { required: "El modelo es requerido" })}
                error={errors.model?.message}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Piso
              </label>
              <CustomInput
                label="Piso"
                type="number"
                {...register("floor", {
                  valueAsNumber: true,
                  min: { value: 1, message: "El piso debe ser mayor a 0" },
                })}
                error={errors.floor?.message}
              />
            </div>
            <div>
              {" "}
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Orientación
              </label>
              <CustomInput
                label="Orientación"
                {...register("orientation")}
                error={errors.orientation?.message}
              />
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Precio de lista
              </label>
              <CustomInput
                label="Precio de lista"
                type="number"
                {...register("list_price", {
                  required: "El precio es requerido",
                  valueAsNumber: true,
                  min: { value: 0, message: "El precio debe ser mayor a 0" },
                })}
                error={errors.list_price?.message}
              />
            </div>
            {type !== 'Local' && <div>
              {" "}
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Número de habitaciones
              </label>
              <CustomInput
                label="Número de habitaciones"
                type="number"
                {...register("rooms_number", {
                  required: "El número de habitaciones es requerido",
                  valueAsNumber: true,
                  min: {
                    value: 1,
                    message: "Debe tener al menos 1 habitación",
                  },
                })}
                error={errors.rooms_number?.message}
              />
            </div>}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Número de baños
              </label>
              <CustomInput
                label="Número de baños"
                type="number"
                {...register("bathrooms_number", {
                  valueAsNumber: true,
                  min: {
                    value: 0,
                    message: "El número debe ser mayor o igual a 0",
                  },
                })}
                error={errors.bathrooms_number?.message}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Lugares de estacionamiento
              </label>
              <CustomInput
                label="Lugares de estacionamiento"
                type="number"
                {...register("parking_places", {
                  valueAsNumber: true,
                  min: {
                    value: 0,
                    message: "El número debe ser mayor o igual a 0",
                  },
                })}
                error={errors.parking_places?.message}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Superficie construida (m²)
              </label>
              <CustomInput
                label="Superficie construida (m²)"
                type="number"
                {...register("building_surface", {
                  valueAsNumber: true,
                  min: {
                    value: 0,
                    message: "La superficie debe ser mayor a 0",
                  },
                })}
                error={errors.building_surface?.message}
              />
            </div>
            {type !== 'Local' && <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Superficie de terraza (m²)
              </label>
              <CustomInput
                label="Superficie de terraza (m²)"
                type="number"
                {...register("terrace_surface", {
                  required: "La superficie de terraza es requerida",
                  valueAsNumber: true,
                  min: {
                    value: 0,
                    message: "La superficie debe ser mayor a 0",
                  },
                })}
                error={errors.terrace_surface?.message}
              />
            </div>}
            {type !== 'Local' && <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Superficie de balcón (m²)
              </label>
              <CustomInput
                label="Superficie de balcón (m²)"
                type="number"
                {...register("balcony_surface", {
                  valueAsNumber: true,
                  min: {
                    value: 0,
                    message: "La superficie debe ser mayor a 0",
                  },
                })}
                error={errors.balcony_surface?.message}
              />
            </div>}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Superficie de bodega (m²)
              </label>
              <CustomInput
                label="Superficie de bodega (m²)"
                type="number"
                {...register("warehouse_surface", {
                  valueAsNumber: true,
                  min: {
                    value: 0,
                    message: "La superficie debe ser mayor a 0",
                  },
                })}
                error={errors.warehouse_surface?.message}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Superficie total (m²)
              </label>
              <CustomInput
                label="Superficie total (m²)"
                type="number"
                {...register("total_surface", {
                  required: "La superficie total es requerida",
                  valueAsNumber: true,
                  min: {
                    value: 0,
                    message: "La superficie debe ser mayor a 0",
                  },
                })}
                error={errors.total_surface?.message}
              />
            </div>
          </div>
          <div className="flex justify-end gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Cancelar
            </button>
            <button
              onClick={handleSubmit(onSubmit)}
              className="flex items-center gap-2 px-4 py-2 bg-nemu-azul text-white rounded-md hover:bg-blue-600"
            >
              <img src={addIcon} alt="guardar" className="w-4 h-4" />
              Guardar cambios
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PropertyEditModal;
